import React from "react";
import MainBannerBG from "../../assets/leadership-bg.png";
import { Link } from "react-router-dom";

function NotFound404() {
  return (
    <>
      <section
        className="py-12 md:py-24 bg-cover bg-center"
        style={{
          backgroundImage: `url(${MainBannerBG})`,
        }}
      >
        <div className="w-full max-w-[1570px] px-4 mx-auto">
          <div className="flex flex-wrap -mx-4">
            <div className="w-full max-w-full px-4 text-center">
              <div className="flex justify-center text-[160px] md:text-[200px] lg:text-[240px] font-black leading-[1] text-[#5fa3b2] -tracking-[0.02em]">
                <span className="rotate-[-16.9deg]">4</span>
                <span className="rotate-[13.63deg]">0</span>
                <span className="rotate-[17.84deg]">4</span>
              </div>
              <h1 className="text-[30px] md:text-[40px] lg:text-[52px] font-bold leading-tight text-[#333333] mb-4">
                Oops! Page not found
              </h1>
              <p className="text-lg font-light leading-7 text-[#333333] mb-8">
                Look like something went wrong! The page you were looking for is
                not here.
              </p>
              <Link
                to="/"
                className="inline-block text-lg font-bold leading-6 text-white bg-[#5fa3b2] py-4 px-9 rounded-xl transition-all ease-in-out duration-500 hover:bg-[#FAA42A]"
              >
                Take Me Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default NotFound404;
